module.exports = __webpack_public_path__ + "img/AC.767c21b7.png";